export const siretRegex = /^[0-9]+$/